import apiClient from '@/services/axios'

export async function get(activeSetupQuery) {
  var params = {
    'venue-details-id': activeSetupQuery.venueDetailsId,
    'date-time': activeSetupQuery.dateTime,
  }
  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/active', { params: params });

  if (response) {
    console.log(response);
    return response.data ? response.data : undefined;
  }

  throw new Error('Unable to get venue setups')
}
